import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ListTableQueryPagination } from "../../components/ListTable/ListTableQueyPagination";
import { adminApiService } from "../../../utils/api";
import { GfFeedBack, MuiFilterRequestDto } from "@swagger/typescript-fetch-goflyer";
import { GridFilterModel } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { TableData } from "../../../utils/interface/tableData";
import { AccountCardWrapper } from "../../components/AccountCardWrapper";
import { useFeedBackTableColumns } from "./useFeedBackTableColumns";
import { SetupPageContainer } from "../../../utils/commonStyledComponents/commonStyled";
import { TableWrapper } from "./styled";
import { useQueryParams } from "../../../hooks/useQueryParams";
import { muiFilterModelHasActiveItems } from "../../../utils/muiGridFilterModel";
import { useLatestRequestGuard } from "../../../hooks/useLatestRequestGuard";
import { guardedListFetch } from "../../../utils/guardedListFetch";
import { useAuthHeaders } from "../../../hooks/useAuthHeaders";

const FeedBack = () => {
  const { t } = useTranslation();
  const authHeaders = useAuthHeaders();

  const { paginationModel, sortModel, handleTableChange } = useQueryParams();

  const [paginationLoading, setPaginationLoading] = useState(false);
  const listRequestGuard = useLatestRequestGuard();
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
  });
  const [feedBackList, setFeedBackList] = useState<TableData<GfFeedBack>>();

  const columns = useFeedBackTableColumns();

  const fetchFeedBackList = async () => {
    await guardedListFetch(
      listRequestGuard,
      setPaginationLoading,
      async () =>
        adminApiService.getManyBaseGfFeedBackAdminControllerGfFeedBack(
          undefined,
          undefined,
          undefined,
          undefined,
          sortModel?.length
            ? [`${sortModel[0].field},${sortModel[0]?.sort?.toUpperCase()}`]
            : [`updatedAt,DESC`],
          undefined,
          paginationModel?.pageSize,
          0,
          paginationModel?.page,
          undefined,
        ),
      (feedBackList) => {
        setFeedBackList((prev) => ({
          ...prev,
          rows: feedBackList.data,
          total: feedBackList?.total,
        }));
      },
    );
  };

  const fetchFeedBackListWithFilter = async (
    activeFilterModel: GridFilterModel,
  ) => {
    await guardedListFetch(
      listRequestGuard,
      setPaginationLoading,
      async () => {
        const body: MuiFilterRequestDto = {
          filterModel: {
            items: activeFilterModel.items.map((item) => ({
              field: item.field,
              operator: item.operator,
              value: item.value,
              id: item.id,
            })),
            logicOperator: activeFilterModel.logicOperator as any,
            quickFilterValues: activeFilterModel.quickFilterValues,
            quickFilterLogicOperator:
              activeFilterModel.quickFilterLogicOperator as any,
          },
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel: sortModel?.map((s) => ({
            field: s.field,
            sort: s.sort as any,
          })),
        };
        return adminApiService.gfFeedBackAdminControllerFilterWithMuiGrid(
          body,
          authHeaders,
        );
      },
      (response) => {
        if (!response) return;
        setFeedBackList((prev) => ({
          ...prev,
          rows: response.rows,
          total: response.total,
        }));
      },
    );
  };

  const handleFilterModelChange = (newFilterModel: GridFilterModel) => {
    setFilterModel(newFilterModel);
  };

  useEffect(() => {
    setFeedBackList({
      columns: columns,
    });
  }, []);

  useEffect(() => {
    const hasActiveFilters = muiFilterModelHasActiveItems(filterModel);
    if (hasActiveFilters) {
      fetchFeedBackListWithFilter(filterModel);
    } else {
      fetchFeedBackList();
    }
  }, [paginationModel, sortModel, filterModel]);

  return (
    <SetupPageContainer>
      <AccountCardWrapper title={t(messages.FEEDBACK()) as string}>
        <Box mt={2}>
          <TableWrapper>
            <ListTableQueryPagination
              loadFailed={listRequestGuard.loadFailed}
              columns={feedBackList?.columns}
              rows={feedBackList?.rows}
              total={paginationLoading ? 0 : feedBackList?.total}
              paginationModel={paginationModel}
              sortModel={sortModel}
              isLoading={paginationLoading}
              onTableChange={handleTableChange}
              dynamicHeightAdjuster={180}
              filterModel={filterModel}
              onFilterModelChange={handleFilterModelChange}
            />
          </TableWrapper>
        </Box>
      </AccountCardWrapper>
    </SetupPageContainer>
  );
};

export default FeedBack;
